import { message, Row, Col, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ButtonItem,
    ErrorItem,
    SelectItem,
    NotificacionPolizas,
} from "../../../../Components/Items";

const { Option } = Select;

class CambiarFamilia extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        objetoFamilias: null,
    };

    componentDidUpdate(prevProps) {
        // Solo consulta si el modal acaba de abrirse
        if (!prevProps.visible && this.props.visible) {
            this.consultarFamilias();
        }
    }



    consultarFamilias = async () => {
        this.setState({ loading: true });

        await axios
            .post(
                "familias/selectFamilias",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status !== 404) {
                    this.setState({
                        objetoFamilias: res.data.map((familia) => (
                            <Option key={familia._id} value={familia._id}>
                                {familia.nombre}
                            </Option>
                        )),
                    });
                } else {
                    message.error(res.data.message || "Error al cargar las familias");
                }
            })
            .catch((error) => {
                console.error("Error al consultar familias:", error);
                message.error("Error al cargar las familias");
            });

        await axios.post("insumos/datosInsumoFamilia",
            {
                insumoId: this.props.id,
            },
            {
                headers: this.props.headersToken
            }).then((res) => {
                if (res.data.success === 2) {
                    this.formRef.current.setFieldsValue({
                        familiaAnteriorId: res.data.familiaId,
                    });
                } else {
                    message.error(res.data.message || "Error al cargar los datos del insumo");
                }
            })
            .catch((error) => {
                console.error("Error al consultar datos del insumo:", error);
                message.error("Error al cargar los datos del insumo");
            });



        this.setState({ loading: false });
    };


    cerrarCambiarFamilia(codigo) {
        this.props.cerrarCambiarFamilia(codigo);
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onFinish(values) {
        this.setState({ loading: true });

        axios
            .post(
                "insumos/cambiarFamilia",
                { ...values, empresaId: this.props.empresaId, insumoId: this.props.id },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });

                if (res.data.success === 2) {
                    message.success("Familia cambiada correctamente");
                    NotificacionPolizas(res.data.polizasId)
                    this.formRef.current.resetFields();
                    this.cerrarCambiarFamilia();
                } else {
                    message.error(res.data.message || "Error al editar la familia");
                }

            })
            .catch((err) => {
                this.setState({ loading: false });
                console.error(err);
                message.error("Error al conectar con el servidor");
            });
    }



    render() {
        return (
            <ModalItem
                title="Cambiar Familia"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={() => this.cerrarCambiarFamilia()}
                width={600}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="cambiarFamilia"
                    layout
                    bottom={
                        <ButtonItem
                            type="primary"
                            htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                        >
                            Editar
                        </ButtonItem>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <h3 style={{ textAlign: 'center', width: '100%' }}>No se recomienda cambiar la familia a menos que sea necesario.</h3>
                    <h3 style={{ textAlign: 'center', width: '100%', marginBottom: '10px' }}>Esto requiere de calculos y movimientos contables, no lo haga con frecuencia.</h3>
                    <Row style={{ width: "100%" }}>
                        <Col span={24}>
                            <FormItem
                                name="familiaAnteriorId"
                                label="Familia Anterior"
                                required
                                margin
                            >
                                <SelectItem disabled>
                                    {this.state.objetoFamilias}
                                </SelectItem>
                            </FormItem>
                            <FormItem
                                name="familiaSiguienteId"
                                label="Familia Siguiente"
                                required
                                margin
                            >
                                <SelectItem placeholder="Selecciona la familia siguiente">
                                    {this.state.objetoFamilias}
                                </SelectItem>
                            </FormItem>
                        </Col>

                    </Row>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(CambiarFamilia);
